import { ProjectJournal } from 'src/screens/shared/project/journal/ProjectJournal'
import { PROJECT } from 'src/shared/constants/constants'

export const PfKapProjectJournalPage = () => {
  return <ProjectJournal projectType={PROJECT.PF_KAP} />
}
